<p-dialog
        header="Add Manually"
        [(visible)]="visible"
        [modal]="true"
        (onHide)="visibleChange.emit(false)"
        [style]="{ width: '460px' }"
        contentStyleClass="p-0">

    @if (visible) {


        <div class="p-4 flex flex-column gap-4">

            <!-- Name -->
            <div class="flex flex-column gap-1">
                <label class="font-medium text-sm">
                    Name <span class="text-red-500">*</span>
                </label>

                <input
                        pInputText
                        [(ngModel)]="form.name"
                        required
                        class="w-full"
                        [ngClass]="{ 'p-invalid': isNameInvalid }"
                />

                <small *ngIf="isNameInvalid" class="text-red-500">
                    Name is required
                </small>
            </div>

            <!-- Planned Date -->
            <div class="flex flex-column gap-2">
                <label class="font-medium text-sm">Planned Date</label>

                <p-date-picker
                        [(ngModel)]="form.plannedDate"
                        dateFormat="dd.mm.yy"
                        appendTo="body"
                        class="w-full">
                </p-date-picker>
            </div>

            <!-- Amount -->
            <div class="flex flex-column gap-1">
                <label class="font-medium text-sm">
                    Amount (EUR) <span class="text-red-500">*</span>
                </label>

                <p-inputNumber
                        [(ngModel)]="form.amount"
                        [min]="0"
                        mode="decimal"
                        [minFractionDigits]="2"
                        [maxFractionDigits]="2"
                        class="w-full"
                        [ngClass]="{ 'p-invalid': isAmountInvalid }"
                ></p-inputNumber>

                <small *ngIf="isAmountInvalid" class="text-red-500">
                    Amount must be greater than 0
                </small>
            </div>

        </div>

        <div class="flex justify-content-end gap-2 p-3 border-top-1 surface-border">

            <p-button
                    label="Cancel"
                    class="p-button-text"
                    (click)="cancel()">
            </p-button>

            <p-button
                    label="Add Payment"
                    icon="pi pi-check"
                    [disabled]="!isFormValid"
                    (click)="submit()">
            </p-button>

        </div>

    }
</p-dialog>
